import { render, staticRenderFns } from "./LastStepColumn.vue?vue&type=template&id=6c2cd6e2&scoped=true"
import script from "./LastStepColumn.ts?vue&type=script&lang=ts&external"
export * from "./LastStepColumn.ts?vue&type=script&lang=ts&external"
import style0 from "./LastStepColumn.vue?vue&type=style&index=0&id=6c2cd6e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2cd6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2cd6e2')) {
      api.createRecord('6c2cd6e2', component.options)
    } else {
      api.reload('6c2cd6e2', component.options)
    }
    module.hot.accept("./LastStepColumn.vue?vue&type=template&id=6c2cd6e2&scoped=true", function () {
      api.rerender('6c2cd6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/list/columns/LastStepColumn/LastStepColumn.vue"
export default component.exports